import type { State } from '@hookstate/core';
import { Grid } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod';
import FilterAutocompleteWorkShiftType from '~/components/FilterAutocompleteWorkShiftType';
import type { WorkShiftTypeResponse } from '~/components/FilterAutocompleteWorkShiftType/interfaces';

interface AssociateShiftAndDateProps {
  readonly startDate: State<string | null>;
  readonly endDate: State<string | null>;
  readonly initialPeriodCreated: State<string>;
  readonly workShift: State<WorkShiftTypeResponse | null>;
  readonly disabledFields?: boolean;
  readonly onPeriodChangeCreated: (period: string) => void;
  readonly defineEndDateRestHours: (startDate: Dayjs) => void;
}

export default function AssociateShiftAndDate({ startDate, endDate, workShift, initialPeriodCreated, onPeriodChangeCreated, defineEndDateRestHours, disabledFields }: AssociateShiftAndDateProps) {

  return (
    <Grid container xs={12} spacing={2}>
      <Grid item xs={2}>
        <FilterAutocompleteWorkShiftType
          workShiftTypeId={workShift.get()?.id}
          onWorkShiftTypeChange={(workShiftType) => {
            workShift.set(workShiftType);

            if (workShiftType === null) {
              initialPeriodCreated.set('clear')
              return false;
            }

            defineEndDateRestHours(dayjs(startDate.get()))
          }}
          disabled={disabledFields}
          isRequired
        />
      </Grid>
      <FilterSelectPeriod
        onStartDateChange={(value) => {
          startDate.set(value?.toJSON() ?? null);
          defineEndDateRestHours(dayjs(startDate.get()));
        }}
        onFinishDateChange={(value) => {
          // data final é definida automaticamente pelo turno e data inicial selecionadas
        }}
        endDateValue={endDate.get() ?? null}
        startDateValue={startDate.get() ?? null}
        onPeriodChange={onPeriodChangeCreated}
        period={initialPeriodCreated.get()}
        hidePeriod={true}
        required
        xsDateBetween={2}
        disabledEndDate={true}
        disableFuture={false}
        disabled={disabledFields}
      />
    </Grid>
  )
}